import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ConfigServiceProvider} from "../../../services/config/config.service.provider";
import {AppConfigService} from "../../../services/app-config.service";

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ConfigServiceProvider
  ]
})
export class HomeLayoutComponent implements OnInit {

  constructor(public appConfigService: AppConfigService) {

  }

  ngOnInit(): void {
  }


}






